/*
 * @Author: wencd wencd@yxt.com
 * @Date: 2022-09-23 14:35:07
 * @LastEditors: wencd wencd@yxt.com
 * @LastEditTime: 2022-09-29 17:19:57
 * @FilePath: \yxt-biz-pc\packages\board-audit\src\service.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { bbsApi } from 'yxt-biz-pc/packages/api';
/**
 * 获取帖子详情
 */
export const getPostDeatilApi = (id) => {
  return bbsApi.get(`/posts/audit/${id}`);
};
